<template>
  <div>
    <v-row class="mt-4">
      <v-col cols="6" sm="3" md="2">
        <decimal-number-input dense label="LCBO Retail price" :suffix="product.bottlesPerUnit===1 ? '/bottle' : '/unit'"
                              v-model="product.defaultPrice"/>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-on="tooltip" icon small class="mt-1" @click="calcRetail"><v-icon>mdi-calculator</v-icon></v-btn>
          </template>
          Calculate shelf price from default in-bond case price
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="includeDirectDelivery">
      <v-col cols="6" sm="3" md="2">
        <decimal-number-input dense label="Direct delivery price" suffix="/case"
                              v-model="directDeliveryPrice"/>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <v-autocomplete  outlined dense label="Direct delivery tax" v-model="directDeliveryTaxId" :items="taxes" item-value="id" item-text="name"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="3" md="2">
        <decimal-number-input dense label="Licensee price" :suffix="product.bottlesPerUnit===1 ? '/bottle' : '/unit'"
                              v-model="licenseePrice" disabled hint="Calculated automatically" persistent-hint/>
      </v-col>
    </v-row>
   </div>
</template>

<script>

export default {
  name: 'DutyPaidSelling',
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true},
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      directDeliveryPrice: 0,
      licenseePrice: 0,
      includeDirectDelivery: false,
      directDeliveryTaxId: '',
      defaultCustomer: ''
    }
  },
  watch: {
    async product() {
      if (this.product.customers[0]) {
        this.directDeliveryPrice = this.product.customers[0].price;
        this.directDeliveryTaxId = this.product.customers[0].taxId;
      }
      else {
        const customers = (await this.$store.dispatch('customers')).filter(customer => customer.type === 'LCBOInBond');
        if (customers.length)
          this.product.customers.push({customerId:customers[0].id,price:0,taxId:'',sku:'',category:false});
      }
    },
    directDeliveryPrice() {
      this.product.customers[0].price = this.directDeliveryPrice;
    },
    directDeliveryTaxId() {
      this.product.customers[0].taxId = this.directDeliveryTaxId;
    },
    async 'product.defaultPrice'() {
      this.getLicenseePrice();
    },
    async taxes() {
      const tax = this.taxes.find(tax => tax.name === 'Exempt');
      this.product.defaultTaxId = tax?.id;
    },
    valid() {
      this.$emit('input', this.valid);
    }
  },
  async created() {
    const results = await this.$apiCall(`query DutyPaidSelling {
                                                    ontarioPreferences {
                                                      lcboDirectDeliveryFromDutyPaid
                                                    }
                                                  }`,
                                                {});
    if (!results.error)
      this.includeDirectDelivery = results.data.ontarioPreferences.lcboDirectDeliveryFromDutyPaid;
  },
  methods: {
    async calcRetail() {
      const results = await this.$apiCall(`query DutyPaidSelling($input: OntarioShelfPriceInput!) {
                                              ontarioShelfPrice(input:$input)
                                            }`,
                                            {input:{bottleSize:this.product.bottleSize??750,
                                                    caseSize:this.product.caseSize,
                                                    strength:this.product.strength,
                                                    caseQuote:this.product.defaultBondedPrice}});
      if (!results.error)
        this.product.defaultPrice = results.data.ontarioShelfPrice;
    },
    async getLicenseePrice() {
      const results = await this.$apiCall(`query DutyPaidSelling($input: OntarioLicenseePriceInput!) {
                                              ontarioLicenseePrice(input:$input)
                                            }`,
                                            {input:{retailPrice:this.product.defaultPrice, bottleSize:this.product.bottleSize??750}});
      if (!results.error)
        this.licenseePrice = results.data.ontarioLicenseePrice;
    }
  }
}
</script>